import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItem, LineItemMedia, LineItemContent } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/inventory';
import '@grandvisionhq/shipping';
import '../../../context/Cart/context.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { PricesContainer } from '../containers/PricesContainer.js';
import { RemoveLineItemContainer } from '../containers/RemoveLineItemContainer.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '@grandvisionhq/frk-routing';

const UnavailableLineItem = ({ lineItem , lineItemMediaIcon  })=>{
    const { imageUrl , isGift , price , productUrl , name , subtitle , imageAlt  } = lineItem;
    return /*#__PURE__*/ React.createElement(LineItem, {
        className: "line-item line-item--unavailable-line-item"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__media"
    }, lineItemMediaIcon && /*#__PURE__*/ React.createElement(LineItemMedia, swcHelpers.extends({
        type: "icon"
    }, lineItemMediaIcon)), /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "line-item__image",
        type: "image",
        href: productUrl,
        imageUrl: imageUrl,
        imageAlt: imageAlt
    })), /*#__PURE__*/ React.createElement(LineItemContent, {
        className: "line-item__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__description"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "line-item__title"
    }, name), subtitle && /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body"
    }, subtitle)), /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity-and-price"
    }, !isGift && /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity-selector"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__delete-btn"
    }, /*#__PURE__*/ React.createElement(RemoveLineItemContainer, {
        lineItem: lineItem
    })))), /*#__PURE__*/ React.createElement(PricesContainer, {
        discount: price.total.discount,
        originalPrice: price.total.original,
        totalPrice: price.total.gross
    }))));
};

export { UnavailableLineItem };
//# sourceMappingURL=UnavailableLineItem.js.map
